import { apiFetch } from '../../../shared/api/apiFetch'

/**
 * A trail camera as the team map draws it. Trail cameras live in the Burrel
 * database rather than in the shared `mapPins` collection, so they arrive on
 * their own endpoint and get merged onto the map client-side.
 *
 * The API only returns LOCATED cameras — one that has never reported a position
 * and has no manual one is not a pin — so latitude/longitude are always present.
 */
export interface TeamCameraPinDto {
  id: string
  name: string | null
  latitude: number
  longitude: number
  /** True for a camera the signed-in user owns; false when they only see it
      through a share. Decides the pin type, since the same camera is "mine" to
      its owner and "shared" to every other member of the team. */
  ownedByMe: boolean
}

interface ListTeamCameraPinsResponse {
  items: TeamCameraPinDto[]
}

export async function listTeamCameraPins(
  teamId: string,
  token: string,
): Promise<TeamCameraPinDto[]> {
  const r = await apiFetch<ListTeamCameraPinsResponse>(
    `/clubhouse/groups/${encodeURIComponent(teamId)}/camera-pins`,
    { token },
  )
  return r.items
}
